import { routesPath } from '@router/routes';
import { Layout } from '@components/Layout/Layout';
import { SubjectList } from '../pages/ValidationSpecialist/SubjectList/SubjectList';
import { SubjectDetails } from '../pages/ValidationSpecialist/SubjectDetails/SubjectDetails';
import { UserRoles } from '@dynamika-shared/types/auth';
import { WithUserRolesHoc } from '@components/HOC/WithUserRoles/WithUserRoles.hoc';
import { SiteUserLayout } from '@components/SiteUserLayout/SiteUserLayout';
import { SelectClinicalTrialForRole } from '@components/LoginSelections/SelectClinicalTrialForRole';
import { ValidationSpecialistMenu } from '@components/Sidebar/Menu/ValidationSpecialistMenu/ValidationSpecialistMenu';

export const ValidationSpecialistRoutes = [
  {
    path: routesPath.validationSpecialistSubjects,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.VALIDATION_SPECIALIST]}>
        <SiteUserLayout>
          <SelectClinicalTrialForRole />
        </SiteUserLayout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.validationSpecialistSubjectsClinicalTrial,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.VALIDATION_SPECIALIST]}>
        <Layout menuComponent={ValidationSpecialistMenu}>
          <SubjectList />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.validationSpecialistSubjectDetail,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.VALIDATION_SPECIALIST]}>
        <Layout menuComponent={ValidationSpecialistMenu}>
          <SubjectDetails />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
  {
    path: routesPath.validationSpecialistSubjectDetailClinicalTrial,
    element: (
      <WithUserRolesHoc allowedRoles={[UserRoles.VALIDATION_SPECIALIST]}>
        <Layout menuComponent={ValidationSpecialistMenu}>
          <SubjectDetails />
        </Layout>
      </WithUserRolesHoc>
    ),
  },
];
